import { getYoutubeEmbedUrl } from './product';

let apiPromise;

export const getYouTubeVideoId = (url) => {
  const embedUrl = getYoutubeEmbedUrl(url);
  return embedUrl ? new URL(embedUrl).pathname.split('/').pop() : '';
};

// One official script for all console mounts; retain any pre-existing ready callback.
export const loadYouTubeIframeAPI = () => {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  if (apiPromise) return apiPromise;

  apiPromise = new Promise((resolve, reject) => {
    const previousReady = window.onYouTubeIframeAPIReady;
    const existingScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
    const script = existingScript || document.createElement('script');
    let timeout;

    const cleanup = () => {
      clearTimeout(timeout);
      script.removeEventListener('error', onError);
      if (window.onYouTubeIframeAPIReady === onReady) window.onYouTubeIframeAPIReady = previousReady;
    };
    const onError = () => {
      cleanup();
      if (!existingScript) script.remove();
      apiPromise = undefined;
      reject(new Error('No se pudo cargar YouTube.'));
    };
    const onReady = () => {
      cleanup();
      if (window.YT?.Player) resolve(window.YT);
      else {
        apiPromise = undefined;
        reject(new Error('YouTube no está disponible.'));
      }
      previousReady?.();
    };

    window.onYouTubeIframeAPIReady = onReady;
    script.addEventListener('error', onError);
    timeout = setTimeout(onError, 20000);
    if (!existingScript) {
      script.src = 'https://www.youtube.com/iframe_api';
      script.async = true;
      document.head.appendChild(script);
    }
  });
  return apiPromise;
};

export const formatPlaybackTime = (seconds) => {
  const value = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  const remainder = String(value % 60).padStart(2, '0');
  return hours ? `${hours}:${String(minutes).padStart(2, '0')}:${remainder}` : `${minutes}:${remainder}`;
};
